'use strict';

/**
 * @param {AppLibrary} library
 * @param {string} appName
 * @constructor
 */
export let Loader = function (library, appName) {

  /**
   * @type string
   */
  let currentPage = library.getCurrentPage();

  /**
   * @type {string}
   */
  let loadJQuery = '';

  /**
   * @type {{selectorPicker: function|bool|null, appResources: [{url: string, pages: [string]}]}}
   */
  let params = {
    selectorPicker: null,
    appResources: []
  };

  /**
   * @param {string} min
   * @param {string} recommended
   */
  this.requireJQuery = function (min, recommended = '') {
    if (!recommended) {
      recommended = min;
    }
    if (typeof jQuery === 'undefined' || parseFloat(jQuery.fn.jquery) < parseFloat(min)) {
      loadJQuery = recommended;
    }
  };

  /**
   * @param {function(string)|bool} callback
   *        Function to check if SP should start in the current page (will be passed to that func.) or true to start SP unconditionally
   */
  this.enableSelectorPicker = function (callback) {
    params.selectorPicker = callback
  };

  /**
   * Parsing CSS styles from Add To Cart
   * @param config
   */
  this.enableStylePicker = function (config) {
    if (isNaN(parseInt(library.requestGetVars()['style-picker']))) {
      return; // style-picker URL variable is empty
    }
    let adminWindow = window.opener,
        responseData = {},
        element;

    (() => {
      if (!adminWindow) {
        responseData.error = 'Window Opener not detected';
        return;
      }

      let atcSelector = config.getATCSelector(library.getCurrentPage());
      if (!atcSelector) {
        responseData.error = 'No `Add To Cart` selector';
        return;
      }

      try {
        element = document.querySelector(atcSelector);
      } catch (e) {
        responseData.error = 'Invalid `Add To Cart` selector';
        return;
      }
      if (element) {
        let styles = window.getComputedStyle(element);
        let stylesData = JSON.parse(JSON.stringify(styles));
        stylesData.length = styles.length;
        responseData.atc = stylesData;
      } else {
        responseData.error = 'No `Add To Cart` button found';
      }
    })();

    adminWindow.postMessage(JSON.stringify(responseData), '*');
    window.close();
  };

  /**
   * @param {string} url
   * @param {[string]} pages
   */
  this.addResources = function (url, pages = []) {
    if (!Array.isArray(pages)) {
      pages = [pages];
    }
    params.appResources.push({
      url: url,
      pages: pages
    });
  };

  /**
   * @param {function(jQuery, string)} appEntryPoint
   */
  this.run = function (appEntryPoint) {
    try {
      if (loadJQuery !== '') {
        library.loadStatic(
            '//ajax.googleapis.com/ajax/libs/jquery/' + loadJQuery + '/jquery.min.js',
            function () {
              let $ = jQuery.noConflict(true);
              runApp($, appEntryPoint);
            }
        );
      } else {
        runApp(typeof (jQuery) !== 'undefined' ? jQuery : null, appEntryPoint);
      }
    } catch (e) {
      throw new Error('Exception while loading jQuery: ' + e.message);
    }
  };

  /**
   * @param {jQuery} $
   * @param {function(jQuery, string)} appEntryPoint
   */
  let runApp = function ($, appEntryPoint) {
    let _GET = library.requestGetVars();
    if (params.selectorPicker && typeof (_GET.sign) !== 'undefined' && _GET.sign === appName) {
      if (typeof (params.selectorPicker) !== 'function' || params.selectorPicker(currentPage)) {
        library.loadStatic(_GET.script);
      }
      return;
    }

    library.loadStatic(
        getResources(currentPage),
        () => {
          library.onLoad(() => {
            // Run App
            appEntryPoint($, currentPage);
          });
        }
    );
  };

  /**
   * @param {string} page
   * @return {[string]}
   */
  let getResources = function (page) {
    let resources = [];
    for (let i = 0; i < params.appResources.length; i++) {
      let resource = params.appResources[i];
      if (!resource.pages.length || resource.pages.indexOf(page) !== -1 || resource.pages.indexOf('all') !== -1) {
        resources.push(resource.url);
      }
    }
    return resources;
  };
};
